import createAction from '../services/create-action';

export const UPDATE_TEXT_EDITOR = 'textEditor/UPDATE';

export const updateTextEditor = createAction(UPDATE_TEXT_EDITOR);



// WEBPACK FOOTER //
// ./app/actions/update-text-editor.js